/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const validationWorkflowUpdateSlugRegExp = new RegExp('[-a-zA-Z0-9_]+');

export const ValidationWorkflowUpdate = zod.strictObject({
    slug: zod.string().regex(validationWorkflowUpdateSlugRegExp),
});

export type ValidationWorkflowUpdate = zod.input<
    typeof ValidationWorkflowUpdate
>;
export type ValidationWorkflowUpdateOutput = zod.output<
    typeof ValidationWorkflowUpdate
>;
